/**
 * דגל המסכים הישנים של ממשק הנציג.
 *
 * האפיון (פרקים 3.1 ו-5) מגדיר לנציג בדיוק שלוש לשוניות — "בטיפולי",
 * "שיחות מעקב" ו"חיפוש" — לצד סופטפון קבוע וכפתור תותח. אין לשונית חיוג
 * ידני, אין לשונית הקלטות ואין לשונית הגדרות.
 *
 * שאר המסכים (סופטפון כדף, שיחה פעילה, קמפיין יוצא, היסטוריה, אנשי קשר,
 * תא קולי, משימות, פניות תמיכה, משמרות, הגדרות, עזרה) **לא נמחקו**: הקוד
 * והנתיבים ממשיכים לעבוד, הם פשוט לא מוצגים בתפריט כברירת מחדל. מי שיש לו
 * קישור ישיר (או ניווט תוכנתי) עדיין מגיע אליהם.
 *
 * איך מדליקים חזרה:
 *   1. בזמן build — `VITE_AGENT_LEGACY_SCREENS=1` (‎.env / משתנה סביבה
 *      ב-Coolify). זה המתג היחיד; הוא שולט על התפריט כולו.
 *   2. בזמן ריצה לבדיקה — `localStorage.setItem('merkaziya-agent-legacy-screens', '1')`
 *      ורענון. שימושי כדי לאמת מסך ישן בפרודקשן בלי build מחדש.
 *
 * כשמחליטים סופית למחוק את המסכים — מוחקים את הקובץ הזה, את ה-NAV הישן
 * ב-AgentLayout ואת ה-routes המתאימים ב-App.tsx.
 */

const STORAGE_KEY = 'merkaziya-agent-legacy-screens';

/** האם להציג בתפריט הנציג את המסכים שמחוץ לאפיון שלוש-הלשוניות. */
export function legacyAgentScreensEnabled(): boolean {
  if (import.meta.env.VITE_AGENT_LEGACY_SCREENS === '1') return true;
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // דפדפן שחוסם אחסון — נשארים על ברירת המחדל (שלוש לשוניות בלבד).
    return false;
  }
}
